<template>
  <FullWidthSectionLayout :title="title">
    <component v-bind:is="report"></component>
  </FullWidthSectionLayout>
</template>

<script>
import FullWidthSectionLayout from '@/layouts/FullWidthSectionLayout'

const ReportBuilder = () => import('../components/reports/ReportBuilder')

export default {
  name: 'ReportsPage',
  components: {
    FullWidthSectionLayout,
    ReportBuilder
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      title: ''
    }
  },
  mounted() {
    if (this.slug == 'all') {
      this.title = 'Svi izvestaji'
    } else {
      this.title = 'Izvestaj o incidentima'
    }
  },
  computed: {
    report() {
      if (this.slug == 'all') {
        return 'ReportBuilder'
      }
      return 'IncidentReports'
    }
  }
}
</script>
